import React from 'react';
import Post from './Post';

function PostList({ posts, excludeIds = [], sortDirection = 'desc' }) {
  // Convert posts object to array and sort by date
  const postsArray = Object.values(posts)
    .filter(post => !excludeIds.includes(post.id))
    .sort((a, b) => {
      // Use publishedAt if available, fall back to lastModified
      const dateA = new Date(a.publishedAt || a.lastModified);
      const dateB = new Date(b.publishedAt || b.lastModified);
      
      if (sortDirection === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });
  
  return (
    <div className="post-list">
      {postsArray.map(post => (
        <Post key={post.id} post={post} />
      ))}
    </div>
  );
}

export default PostList;

